'use strict';

frontendApp.controller('AddAccountModalCtrl', ['$scope', '$http', 'ConfigService', function($scope, $http, ConfigService) {

    $scope.saving = false;
    $scope.signUpSuccess = false;

	$scope.saveAccount = function(account) {
		$scope.saving = true;
        
		var data = _.pick(account, 'email', 'firstName', 'lastName', 'phone');
		$http.post(ConfigService.getServerBaseUrl() + "/account/register", data).
			success(function(data, status) {
				$scope.saving = false;
				$scope.signUpSuccess = true;
                
                // Here we're telling the user that he needs to verify email
                
			}).error(function(data, status) {
				$scope.saving = false;
				_.each(data.errors, function(error) {
					$scope.SignUpForm[error.field].$setValidity(error.code, false);
				});
			});
	};

    
}]);
    
